import React from 'react';

export const CloseIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2528_2312)">
        <path
          d="M13.6278 13.4034C13.1315 13.8998 12.3269 13.8998 11.8306 13.4034L7.11216 8.68498L2.16938 13.6278C1.67307 14.1241 0.868546 14.1241 0.372234 13.6278C-0.124078 13.1315 -0.124078 12.3269 0.372234 11.8306L5.31502 6.88784L0.596559 2.16938C0.100247 1.67307 0.100247 0.86791 0.596559 0.372234C1.09287 -0.124078 1.89739 -0.124078 2.3937 0.372234L7.11216 5.09069L11.6057 0.597195C12.102 0.100883 12.9065 0.100883 13.4028 0.597195C13.8991 1.09351 13.8991 1.89803 13.4028 2.39434L8.90931 6.88784L13.6278 11.6063C14.1241 12.1026 14.1241 12.9071 13.6278 13.4034Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2528_2312">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

